/** Iniciais para o avatar das linhas (redesign V3). */
export const iniciais = (nome?: string) =>
  (nome || "")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((n) => n[0])
    .join("")
    .toUpperCase() || "–";
